import React from 'react';
import { Box, Divider, Drawer, IconButton, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { useGlobalization } from '@Translations/useGlobalization';

interface Props {
	open: boolean;
	onClose: () => void;
}

export const TemplateInfoDrawer = ({ open, onClose }: Props) => {
	const { t } = useGlobalization();
	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			sx={{ zIndex: 1400 }}
			PaperProps={{ sx: { width: 440, maxWidth: '100%' } }}>
			<Box sx={{ p: 3 }}>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'flex-start',
						justifyContent: 'space-between',
						gap: 1,
						mb: 1,
					}}>
					<Typography
						sx={{
							fontSize: 18,
							fontWeight: 700,
							color: '#0d1520',
						}}>
						{t('About templates')}
					</Typography>
					<IconButton
						size="small"
						aria-label={t('Close')}
						onClick={onClose}>
						<CloseRounded fontSize="small" />
					</IconButton>
				</Box>
				<Typography sx={{ fontSize: 13, color: '#5b6472', mb: 2 }}>
					{t(
						'A template is a pre-configured starting point built on industry practice — categories, components and weights ready to review.',
					)}
				</Typography>
				<Divider sx={{ mb: 2 }} />
				<Typography
					sx={{ fontSize: 14, fontWeight: 700, color: '#1b2733' }}>
					{t('What applying a template does')}
				</Typography>
				<Typography
					sx={{ fontSize: 13, color: '#3a4451', mt: 0.5, mb: 2 }}>
					{t(
						'It seeds your new model’s categories, components and weights from the template. Nothing is locked — you can adjust or remove anything before you run it.',
					)}
				</Typography>
				<Typography
					sx={{ fontSize: 14, fontWeight: 700, color: '#1b2733' }}>
					{t('Where it comes from')}
				</Typography>
				<Typography sx={{ fontSize: 13, color: '#3a4451', mt: 0.5 }}>
					{t(
						'Each template card shows its provenance — the industry practice or reference data set it’s based on — so you know where the starting point came from.',
					)}
				</Typography>
			</Box>
		</Drawer>
	);
};
